import { shallowEqual, useSelector } from 'react-redux'


const selectorWordBank = (state) => state.wordBankReducer;

export const useSelectorWordBank = () => {   
    const selectedData = useSelector(selectorWordBank, shallowEqual)
    return selectedData;
}